import React from 'react';
import { inject, observer } from 'mobx-react';
import { injectIntl } from 'react-intl';
import { Media, Row, Col } from 'react-bootstrap';
import Attachments from '../common_components/attachments/Attachments';
import Editable from '../common_components/Editable';
import { PropTypes } from "prop-types";
import Text from 'react-format-text';
import StarsRating from '../common_components/StarsRating';
import AttachmentsForm from "../common_components/attachments/AttachmentsForm";
import EditableTextarea from '../common_components/EditableTextarea';

@injectIntl @inject('rootStore', 'feedbackChainsStore', 'authorizationsStore') @observer
export default class FeedbackChain extends React.Component {

    render() {
        const { feedbackChain, intl } = this.props;
        let creator = feedbackChain.creator;
        let createdAt = feedbackChain.createdAt.format('LL');
        let updatedAt = feedbackChain.updatedAt.format('LL');

        return (
            <div className={"feedback-chain"}>
                <div className="Feedback-header">
                    <FeedbackChainTitle feedbackChain={feedbackChain} />
                </div>
                <hr />
                <div>
                    <Media>
                        <Media.Left>
                            <div className={"img-thumbnail img-circle"}>
                                <img className={"img-responsive"}
                                    src={creator.profilePhotoUrl}
                                    alt={creator.name + " thumbnail"} />
                            </div>
                            <div className="creator-name" > {creator.name} </div>
                            <div> {(feedbackChain.controllerName != "") ? ("Controller: " + feedbackChain.controllerName) : ""} </div>
                            <div> {(feedbackChain.actionName != "") ? ("Action: " + feedbackChain.actionName) : ""} </div>
                        </Media.Left>
                        <Media.Body>
                            <Row>
                                <Col xs={12} md={9} className={'feedback-body-container'}>
                                    <div className="feedback-body">
                                        <FeedbackChainDescription feedbackChain={feedbackChain} />
                                        {this.props.authorizationsStore.canEditFeedbackContents(feedbackChain) ? <AttachmentsForm attachable={feedbackChain} /> :
                                            <Attachments attachable={feedbackChain} />}
                                    </div>
                                    <div className="feedback-footer">
                                        <span>{intl.formatMessage({ id: "created_at" })}:&nbsp;{createdAt}</span> &nbsp;
                                        <span>{intl.formatMessage({ id: "updated_at" })}:&nbsp;{updatedAt}</span> &nbsp;
                                        {feedbackChain.isDone() && <span>{intl.formatMessage({ id: "done_at" })}:&nbsp;{feedbackChain.doneAt.format('LL')}</span>}
                                        {feedbackChain.edited && <span>{intl.formatMessage({ id: "contents_edited" })}</span>}
                                    </div>
                                </Col>
                                <Col xs={12} md={3}>
                                    <div className={"user-rating text-muted"}>
                                        <div>{intl.formatMessage({ id: "rating_title" })}</div>
                                        <div className={'rating-container'}>
                                            <StarsRating containerId={'rating'}
                                                initialRating={feedbackChain.rating}
                                                onChange={(val) => feedbackChain.setRating(val)}
                                                readonly={!this.props.authorizationsStore.canRateFeedback(feedbackChain)} />

                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Media.Body>
                    </Media>
                </div>
            </div>
        );
    }

}

@injectIntl @inject('authorizationsStore') @observer
class FeedbackChainTitle extends React.Component {

    render() {
        const { feedbackChain, intl, authorizationsStore } = this.props;
        if (feedbackChain.isEditingTitle) {
            return (
                <div className={'feedback-title'}>
                    <span className="bold feedback-id" > #{feedbackChain.id} </span>
                    <Editable
                        value={feedbackChain.title}
                        placeholder={intl.formatMessage({ id: 'add_title' })}
                        canDelete={false}
                        canEdit={true}
                        onEdit={(value) => feedbackChain.setTitle(value)}
                        maxLength={200}
                    />
                </div>
            );
        }
        return (
            <div className={'feedback-title'}>
                <span className="bold feedback-id" > #{feedbackChain.id} </span>
                <span>{feedbackChain.title}</span>
                {authorizationsStore.canEditFeedbackContents(feedbackChain) &&
                    <i className={'fa fa-pencil top-right btn-transparent'} onClick={() => feedbackChain.setIsEditingTitle(true)}></i>
                }
            </div>
        );
    }
};


@injectIntl @inject('authorizationsStore') @observer
class FeedbackChainDescription extends React.Component {

    render() {
        const { feedbackChain, intl, authorizationsStore } = this.props;
        if (feedbackChain.isEditingDescription) {
            return (
                <div className={'feedback-description'}>
                    <EditableTextarea
                        text={feedbackChain.description}
                        textPlaceholder={intl.formatMessage({ id: 'add_title' })}
                        canDelete={false}
                        canEdit={true}
                        onSubmit={(value) => feedbackChain.setDescription(value)}
                    />



                </div>
            );
        }
        return (
            <div className={'feedback-description'}>
                <Text>{feedbackChain.description}</Text>
                {authorizationsStore.canEditFeedbackContents(feedbackChain) &&
                    <i className={'fa fa-pencil top-right btn-transparent'}
                        onClick={() => feedbackChain.setIsEditingDescription(true)}></i>
                }
            </div>
        );
    }
};
